export default __webpack_public_path__ + "static/media/factory__54.0636d352.jpg";